import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "copyright",
    style: _normalizeStyle({ 'text-align': _ctx.align })
  }, "Copyright " + _toDisplayString(1900 + new Date().getYear()) + " by Ticket Solutions Pty Ltd.", 5))
}